import Cookies from "universal-cookie"

import config from "../config"
import getCompleteApiUrl from "../getCompleteApiUrl"
import {OperatorReadinessProblem} from "../../classes/OperatorReadinessProblem"
import {ApiCallFailure} from "../../classes/exception/ApiCallFailure";

export default async function createReadinessProblemInOperatorById(problem: OperatorReadinessProblem) {
    const cookies = new Cookies()

    if (cookies.get("accessToken") === undefined) {
        const error = new ApiCallFailure()
        error.connectionSuccessful = false
        error.errorType = "NO_ACCESS_TOKEN"

        throw error
    }

    var res: Response
    try {
        res = await fetch(getCompleteApiUrl(config, `/operators/id/${problem.operatorId}/readiness/problems`), {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${cookies.get("accessToken")}`
            },
            body: JSON.stringify({
                subject: problem.subject,
                description: problem.description,
                started: problem.started.format(),
                resolutionExpected: problem.resolutionExpected.format(),
            }),
        })
    } catch (error) {
        const apiFailure = new ApiCallFailure()
        apiFailure.connectionSuccessful = false

        throw apiFailure
    }

    if (res!.status === 201) {
        const responseObject = await res!.json()

        const responseProblem = new OperatorReadinessProblem()
        responseProblem.parseObject(responseObject)

        return responseProblem
    }

    const callFailure = new ApiCallFailure()
    callFailure.connectionSuccessful = true
    callFailure.responseCode = res!.status
    callFailure.errorType = "REQUEST_REJECTED"

    throw callFailure
}